import { LitElement as h, unsafeCSS as n } from "lit";
import { property as r } from "lit/decorators.js";
import m from "../../shared/reset.style.css.js";
import { booleanType as o } from "../../utils/property-types.js";
import u from "./card.style.css.js";
import { template as b } from "./card.template.js";
var y = Object.defineProperty, a = (l, e, i, p) => {
  for (var s = void 0, t = l.length - 1, f; t >= 0; t--)
    (f = l[t]) && (s = f(e, i, s) || s);
  return s && y(e, i, s), s;
};
class d extends h {
  constructor() {
    super(...arguments), this.selected = !1, this.dragged = !1, this.deleted = !1, this.disabled = !1, this.hasClose = !1, this.hasDetails = !1;
  }
  static get styles() {
    return [n(m), n(u)];
  }
  /* METHODS */
  _propagateProperties() {
    var i;
    const e = (i = this.shadowRoot) == null ? void 0 : i.querySelectorAll("slot");
    e && e.forEach((p) => {
      p.assignedElements().forEach((t) => {
        this.deleted ? t.setAttribute("deleted", "true") : t.removeAttribute("deleted"), this.disabled ? t.setAttribute("disabled", "true") : t.removeAttribute("disabled");
      });
    });
  }
  /* EVENTS */
  _dispatchClose() {
    this.dispatchEvent(new CustomEvent("onClose", { bubbles: !0 }));
  }
  /* LIT LIFECYCLE */
  updated(e) {
    super.updated(e), (e.has("deleted") || e.has("disabled")) && this._propagateProperties();
  }
  render() {
    return b(this);
  }
}
a([
  r(o)
], d.prototype, "selected");
a([
  r(o)
], d.prototype, "dragged");
a([
  r(o)
], d.prototype, "deleted");
a([
  r(o)
], d.prototype, "disabled");
a([
  r(o)
], d.prototype, "hasClose");
a([
  r(o)
], d.prototype, "hasDetails");
export {
  d as Card
};
//# sourceMappingURL=card.js.map
